import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { useDiscoveryClient } from '../api/context';
import type { AccountCreateInput } from '../api/types';

export const accountsKey = ['discovery', 'accounts'] as const;

export function useAccounts() {
  const client = useDiscoveryClient();
  return useQuery({
    queryKey: accountsKey,
    queryFn: () => client.accounts.list(),
  });
}

export function useCreateAccount() {
  const client = useDiscoveryClient();
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (input: AccountCreateInput) => client.accounts.create(input),
    onSuccess: () => qc.invalidateQueries({ queryKey: accountsKey }),
  });
}

export function useUpdateAccount() {
  const client = useDiscoveryClient();
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ publicId, patch }: { publicId: string; patch: AccountCreateInput }) =>
      client.accounts.update(publicId, patch),
    onSuccess: () => qc.invalidateQueries({ queryKey: accountsKey }),
  });
}

export function useDeleteAccount() {
  const client = useDiscoveryClient();
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (publicId: string) => client.accounts.delete(publicId),
    onSuccess: () => qc.invalidateQueries({ queryKey: accountsKey }),
  });
}

export function useStartLiveSession() {
  const client = useDiscoveryClient();
  return useMutation({
    mutationFn: (proxy?: string) => client.accounts.liveSession(proxy),
  });
}
